import React from "react";
import {
  QueryVirtualGaps,
  SubscribeVirtualGaps,
} from "../../../utils/graphql/hooks/virtualGapsHooks";

export default function VirtualGapsDataManager() {
  QueryVirtualGaps();
  SubscribeVirtualGaps();
  return <></>;
}
